var _path, _path2, _path3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSalesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_260_5986",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.36526 8.60571C1.32407 8.43419 1.32231 8.25557 1.36011 8.08327C1.39791 7.91098 1.47429 7.7495 1.5835 7.61098C1.69271 7.47246 1.83191 7.3605 1.99063 7.28354C2.14935 7.20657 2.32345 7.1666 2.49984 7.16663H22.8733C23.0497 7.1666 23.2238 7.20657 23.3826 7.28354C23.5413 7.3605 23.6805 7.47246 23.7897 7.61098C23.8989 7.7495 23.9753 7.91098 24.0131 8.08327C24.0509 8.25557 24.0491 8.43419 24.0079 8.60571L21.0679 20.8557C21.0067 21.1105 20.8615 21.3373 20.6557 21.4996C20.4499 21.6618 20.1954 21.75 19.9333 21.75H5.43984C5.17777 21.75 4.92332 21.6618 4.71749 21.4996C4.51166 21.3373 4.36645 21.1105 4.30526 20.8557L1.36526 8.60571Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77018 7.16665V1.33331H5.10352V7.16665H9.77018ZM9.77018 7.16665L13.5618 1.91665L20.8535 7.16665",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43652 11.8333H12.1032",
    stroke: "black",
    strokeWidth: 2.66667,
    strokeLinecap: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_260_5986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.31348 -2.75006H26.6865V25.2499H-1.31348V-2.75006Z",
    fill: "url(#paint0_linear_260_5986)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_260_5986",
    x1: 12.6865,
    y1: -2.75006,
    x2: 12.6865,
    y2: 25.2499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2D55",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2D55"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesIcon);
export default __webpack_public_path__ + "static/media/sales-icon.6482e03baa093d3c78c9e8fa18598bc5.svg";
export { ForwardRef as ReactComponent };